import type { ReactNode } from 'react';

type PageHeroProps = {
  title: ReactNode;
  subtitle?: string;
  image: string;
};

/**
 * Inner-page hero matching the existing About / HSE / Contact heroes.
 */
export default function PageHero({ title, subtitle, image }: PageHeroProps) {
  return (
    <section
      className="relative text-white overflow-hidden h-[400px] flex lg:pb-[70px] pb-0 lg:pl-[140px] pl-0 items-center lg:items-end lg:justify-start justify-center"
      style={{
        backgroundImage: `linear-gradient(90deg, #022843 0%, rgba(2, 40, 67, 0) 100%), url('${image}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="relative z-10 px-6 text-center lg:text-left max-w-3xl">
        <h1 className="text-3xl lg:text-[50px] font-medium mb-[10px] text-white leading-tight">{title}</h1>
        {subtitle && <p className="text-base lg:text-lg text-white/80 leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
